module.exports = __webpack_public_path__ + "static/media/clothes_master.0f4be43e.png";